import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const LineCharts = ({ data, options, style }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        const chartInstance = echarts.init(chartRef.current);

        const defaultOptions = {
            color: ['#4285F4'],
            tooltip: {
                trigger: 'axis',
                textStyle: {
                    fontFamily: 'Inter', // 设置字体样式
                }
            },
            xAxis: {
                type: 'category',
                data: data.labels,
                boundaryGap: false,
            },
            yAxis: {
                type: 'value',
            },
            grid: {
                top: '8%',
                left: '4%',
                right: '4%',
                bottom: '8%',
            },
            series: [
                {
                    name: "Total Clicks",
                    data: data.values,
                    type: 'line',
                    color: '#0068d9',
                    smooth: true,
                    symbol: 'circle', // 设置圆点的形状
                    symbolSize: 4, // 设置圆点的大小
                },
            ],
        };

        const mergedOptions = { ...defaultOptions, ...options };
        if (!chartInstance.isDisposed()) {
            chartInstance.setOption(mergedOptions);
        }

        // const resizeObserver = new ResizeObserver(() => {
        //     chartInstance.resize();
        // });
        // resizeObserver.observe(chartRef.current);

        return () => {
            chartInstance.dispose();
            // resizeObserver.disconnect();
        };
    }, [data, options]);

    return <div ref={chartRef} style={{ width: '100%', height: 320 }}></div>;
};

export default LineCharts;
